<template>
  <div class="row my-2" v-if="display">
    <div class="col-6">
      <div class="bg-cell rounded">
        <div class="captcha p-1 pe-3">
          <i
            class="fi fi-reload float-end mt-1 fs16px ps-3 p-2 pointer"
            @click="refreshButtonClick"
          ></i>
          <template v-for="(char, index) in captchaChars" :key="index">
            <span
              class="captcha-char"
              :style="{
                fontSize: char.fontSize + 'px',
                transform: 'rotate(' + char.rotation + 'deg)',
              }"
            >
              {{ char.char }}
            </span>
          </template>
        </div>
      </div>
    </div>
    <div class="col-6">
      <div class="form-floating">
        <floating-input-with-message
          containerClass=""
          inputPlaceHolder="کد"
          ref="inputEnteredCode"
          v-model:inputValue="enteredData"
          labelClass="text-muted small"
          inputClass="text-center"
          labelValue="کد"
          errorMessage="کد را بدرستی وارد نمایید"
          erroMessageClass="smaller text-danger"
        />
      </div>
    </div>
  </div>
</template>
<script>
import FloatingInputWithMessage from '../../form/floatingInputWithMessage/FloatingInputWithMessage.vue';

export default {
  components: {
    FloatingInputWithMessage,
  },
  props: {
    display: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      captchaChars: [],
      enteredData: '',
      characters:
        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ',
    };
  },

  methods: {
    generateCaptcha() {
      const chars = this.characters.split('');
      let captchaChars = [];
      for (let i = 0; i < 6; i++) {
        let char = chars[Math.floor(Math.random() * chars.length)];
        let fontSize = Math.floor(Math.random() * 10) + 20; // random font size between 20 and 30
        let rotation = Math.floor(Math.random() * 21) - 10; // random rotation between -10 and 10 degrees
        captchaChars.push({ char, fontSize, rotation });
      }
      this.captchaChars = captchaChars;
    },
    refreshButtonClick() {
      this.enteredData = null;
      this.generateCaptcha();
    },
    validateCaptcha() {
      let text = this.captchaChars.map((m) => m.char).join('');
      if (
        this.display &&
        this.enteredData?.toLowerCase() != text?.toLowerCase()
      ) {
        this.$refs.inputEnteredCode.showErrorMessage();
        this.$refs.inputEnteredCode.setFocus();
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.generateCaptcha();
  },
};
</script>
<style scoped>
.captcha {
  direction: ltr !important;
  display: flex;
  align-items: center;
  justify-content: center;
  /* width: 150px;
  height: 50px; */
  /* background-color: #f0f0f0; */
  cursor: pointer;

  height: 60px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
}
.bg-cell {
  background-color: #f0f0f0;
}
.captcha-text {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  text-align: center;
  transform: rotate(-10deg);
  transform-origin: center;
}
</style>
